import { Box, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { width as listWidth } from '../list/styled';

export const UserDetailContainerStyled = styled(Box).attrs({
  pt: { sm: '700' },
  flexDirection: { sm: 'column' },
})`
  width: calc(100% - ${listWidth});
`;
export const SepartorStyled = styled(Box)`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const UserDetailFooterStyled = styled(Box).attrs({
  py: { sm: '500' },
  pr: { sm: '500' },
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;
